// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { Events } from 'constants';

import RestaurantMenuAction from 'actions/RestaurantMenuAction';

import { RestaurantMenuStore } from 'stores';

// -- utils
import SecurityContext from 'utils/permissions/SecurityContext';
import Notify from 'PMT/utils/Notify';

// -- entities
import {
  RestaurantMenu,
  ProductCategory,
  CategoryItem,
} from 'PMT/entities/menu';

// -- views
import AbstractRestaurantMenuComponent from '../components/AbstractRestaurantMenuComponent';
import FixedSubmitArea from 'PMT/components/form/FixedSubmitArea';
import CategoryRow from './components/CategoryRow';
import RoundButton from 'components/RoundButton';
import SortableList from 'PMT/components/SortableList';
import { EditProductCategoryModal } from 'components/restaurantMenu';
import AddItemToCategoryModal from '../category/addItemToCategory/AddItemToCategoryModal';
import UnusedCategoriesListView from './unusedCategories/UnusedCategoriesListView';

export default class CategoriesListPage extends AbstractRestaurantMenuComponent {

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (!nextProps.restaurantMenu.equals(this.state.restaurantMenu)) {
      this.setState({
        restaurantMenu: nextProps.restaurantMenu.copy()
      });
    }
  }

  getDefaultState(): Object {
    return {
      restaurantMenu: this.props.restaurantMenu.copy(),
      displayCreateCategoryModal: false,
      displayEditModal: false,
    }
  }

  onUpdateRestaurantMenuSuccess = () => {
    this.setState({
      loading: false
    });
  };

  //
  //
  //

  onAddCategoryClick = () => {
    this.setState({
      displayCreateCategoryModal: true,
    });
  };

  onHideCategoryCreateModal = () => {
    this.setState({
      displayCreateCategoryModal: false,
    });
  };

  onItemsOrderChange = (categories) => {
    const restaurantMenu: RestaurantMenu = this.restaurantMenu;

    const items = [];
    _.each(categories, (category: ProductCategory) => {
      const item = new CategoryItem();
      item.fromCategory(category);

      items.push(item);
    });

    restaurantMenu.getRootCategory().items = items;

    this.setState({
      restaurantMenu
    });
  };

  onCreateCategory = (restaurantMenu: RestaurantMenu) => {
    this.setState({
      restaurantMenu,
      loading: true,
    }, RestaurantMenuAction.saveRestaurantMenu(restaurantMenu));
  };

  onDeleteCategoryFromRoot = (category: ProductCategory) => {
    Notify.confirm(I18n.tr('menu.category.confirm_deletion_from_root'), (result) => {
      if (result) {
        const restaurantMenu: RestaurantMenu = this.restaurantMenu;

        restaurantMenu.removeCategoryFromRoot(category);

        this.setState({
          restaurantMenu
        });
      }
    });
  };

  onEditClicked = () => {
    this.setState({
      displayEditModal: true
    });
  };

  onHideEditModal = () => {
    this.setState({
      displayEditModal: false
    });
  };

  //
  // getters
  //

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  haveModifications() {
    return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
  }

  //
  // renderers
  //

  renderHeader() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    if (_.isEmpty(this.restaurantMenu.products)) {
      return (
        <p className="bg-warning">
          {I18n.tr('menu.category.error_no_products_exists')}
        </p>
      );
    }

    return (
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <RoundButton
            text={I18n.tr('menu.category.add_category')}
            onClick={this.onAddCategoryClick}
          />
        </div>
        <div className="pull-right">
          <RoundButton
            icon='fa-edit'
            text={I18n.tr('menu.category.edit_main_category')}
            onClick={this.onEditClicked}
          />
        </div>
      </div>
    );
  }

  renderTheadContent() {
    return (
      <div className="thead col-xs-12">
        <div className="hidden-xs col-sm-2 text-left">

        </div>
        <div className="col-xs-8">
          {I18n.tr('menu.category.table.header.name')}
        </div>

        {/* <div className="hidden-xs col-sm-4">
          Description
        </div> */}

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1">
            {I18n.tr('menu.category.table.header.delete_from_main_category')}
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1 text-center">
            {I18n.tr('menu.category.table.header.move')}
          </div>
        }
      </div>
    );
  }

  renderRow = (category: ProductCategory) => {
    return (
      <CategoryRow
        category={category}
        restaurantMenu={this.restaurantMenu}
        key={category.name}
        onDeleteCategoryFromRoot={this.onDeleteCategoryFromRoot}
      />
    );
  };

  renderCategoriesListView() {
    return (
      <SortableList
        items={this.restaurantMenu.getFirstLevelCategories()}
        onChange={this.onItemsOrderChange}
        renderer={this.renderRow}
        displayDragIcon={false}
      />
    );
  }

  renderCreateCategoryModal() {
    const parentsToPropose = this.restaurantMenu.categories;

    if (this.state.displayCreateCategoryModal) {
      return (
        <EditProductCategoryModal
          onCreate={this.onCreateCategory}
          show
          onHide={this.onHideCategoryCreateModal}
          parentsToPropose={parentsToPropose}
          restaurantMenu={this.state.restaurantMenu}
        />
      );
    }

    return (null);
  }

  renderEditModal() {
    if (this.state.displayEditModal) {
      return (
        <AddItemToCategoryModal
          show={this.state.displayEditModal}
          onHide={this.onHideEditModal}
          restaurantMenu={this.props.restaurantMenu}
          productCategory={this.restaurantMenu.getRootCategory()}
        />
      );
    }

    return (null);
  }

  renderUnusedCategories() {
    if (_.isNull(this.restaurantMenu) || _.isEmpty(this.restaurantMenu.categories)) {
      return (null);
    }

    return (
      <div>
        <hr className="top-buffer-50" />

        <UnusedCategoriesListView
          restaurantMenu={this.restaurantMenu}
        />
      </div>
    )
  }

  render() {
    try {
    return (
      <div className="categories_list top-buffer-30">
        {this.renderHeader()}

        {!_.isEmpty(this.restaurantMenu.categories) &&
          <div className="table_container table_container_hover top-buffer-50 row">
            {this.renderTheadContent()}
            {this.renderCategoriesListView()}
          </div>
        }

        {this.renderUnusedCategories()}

        {SecurityContext.restaurantMenu.canEdit() &&
          this.renderFixedButtons()
        }
        {this.renderLoading()}

        {this.renderCreateCategoryModal()}
        {this.renderEditModal()}
      </div>
    ); } catch (e) { console.error(e)}
  }

}
